var $ = require('jquery');
require('mediaelement');
require('promiscuous');
require('whatwg-fetch');
require('@chenfengyuan/datepicker');

var moment = require('moment');
var zoom = require('./zoom');
var murliApp = require('./murli');
var pullToRefresh = require('pulltorefreshjs');

window.addEventListener("orientationchange", function(){
    console.log(screen.orientation.type); // e.g. portrait
    if(device.platform == "iOS") {
        // Force CSS refresh
        $('#css').replaceWith('<link id="css" rel="stylesheet" href="app.css?t=' + Date.now() + '"></link>');
    }
});

document.addEventListener('DOMContentLoaded', () => {

    var d = moment();
    var today = moment();
    var lang = localStorage.getItem("murli.lang");
    var cat = 'daily';

    // Set theme
    var darkTheme = localStorage.getItem("murli.darkTheme");
    if (darkTheme) {
        $('head').append('<link title="dark-theme" rel="stylesheet" href="themes/dark.css" type="text/css" />');
        $("#themeCbx").prop('checked', true);
    }

    var reqUrl = window.location.href;
    //TODO: do regex check.
    var redirectPar = (reqUrl.indexOf("#") > 0) ? reqUrl.substring(reqUrl.indexOf("#") + 1) : null;
    if (redirectPar && redirectPar.length > 0) {
        var params = redirectPar.split(/[\s\+]+/);
        if (params[0])
            lang = params[0];
            if (params[1]) {
                d = moment(params[1], 'YYYY-MM-DD');
                if (!d.isValid || d.isAfter(today.add(1, 'days')))
                    d = today;
            }
        if (params[2])
            cat = params[2];
    }

    if (typeof lang === 'undefined' || lang === null)
        lang = 'hi';
    var config = {
        baseUrl: 'https://madhubanmurli.org/',
        lang: lang,
        cat: cat,
        currentDate: d,
        today: today,
        nextDate: moment(d).add(1, 'days'),
        previousDate: moment(d).subtract(1, 'days')
    };
    murliApp.init(config);

    $(function () {
        $('.headroom').each(function () {
            var $win = $(window), $self = $(this), isHidden = false, lastScrollTop = 0;

            $win.on('scroll', function () {
                var scrollTop = $win.scrollTop();
                var offset = scrollTop - lastScrollTop;
                lastScrollTop = scrollTop;

                // min-offset, min-scroll-top
                if (offset > 10 && scrollTop > 200 ) {
                    if (!isHidden) {
                        $self.addClass('headroom-hidden');
                        isHidden = true;
                    }
                } else if (offset < -30 || scrollTop < 200) {
                    if (isHidden) {
                        $self.removeClass('headroom-hidden');
                        isHidden = false;
                    }
                }
            })
        });

        $('.footroom').each(function () {
            var $win = $(window), $self = $(this), isHidden = false, lastScrollTop = 0;

            $win.on('scroll', function () {
                var scrollTop = $win.scrollTop();
                var offset = scrollTop - lastScrollTop;
                lastScrollTop = scrollTop;

                // min-offset, min-scroll-top
                if (offset > 10 && scrollTop > 200 ) {
                    if (!isHidden) {
                        $self.addClass('footroom-hidden');
                        isHidden = true;
                    }
                } else if (offset < -30 || scrollTop < 200) {
                    if (isHidden) {
                        $self.removeClass('footroom-hidden');
                        isHidden = false;
                    }
                }
            });
        });
    });
    zoom.init();
    pullToRefresh.init({
        mainElement: 'body',
        onRefresh() {
            window.location.reload();
        }
        /*
        iconArrow: ReactDOMServer.renderToString(
            <FontAwesomeIcon icon={faSyncAlt} />
        ),
        iconRefreshing: ReactDOMServer.renderToString(
            <FontAwesomeIcon icon={faSyncAlt} spin={true} />
        ),*/
    });
});
